export const storageOptionalMetadataKey = Symbol('storage:optional');

export default function storageOptional<C>(...keys: Array<keyof C>) {
    return (ctor: any) => {
        const parentKeys: Array<string> = Reflect.getMetadata(storageOptionalMetadataKey, ctor) ?? [];

        Reflect.defineMetadata(storageOptionalMetadataKey, [...parentKeys, ...keys], ctor);
        return ctor;
    }
}